import axios from "axios";
import { useAuth } from "@/store/authStore";

export const API_URL = __IS_DEV__ ? "/api" : `${__API_URL__}/api`;

const $api = axios.create({
  withCredentials: true,
  baseURL: API_URL,
  xsrfHeaderName: "X-CSRFToken",
  xsrfCookieName: "csrftoken",
});

$api.interceptors.request.use((config) => {
  const { initData, sessionToken } = useAuth.getState();

  if (initData) {
    config.headers["X-Telegram-Init-Data"] = initData;
    return config;
  }

  if (sessionToken) {
    config.headers["X-Auth-Session"] = sessionToken;
  }

  return config;
});

export default $api;
